import { FormattedMessage } from 'react-intl'
import { rem } from 'polished'
import styled from 'styled-components'

import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import Sheet from 'components/utils/Sheet'

const Banner = styled(Sheet)`
  flex-shrink: 0;
  display: grid;
  grid-template-columns: 1fr auto;
  align-items: center;
  gap: ${rem(8)};
`

const Message = styled(BodyText)`
  min-width: 0;
`

interface Props {
  chatId: number
  onDismiss: () => void
}

/**
 * Warning banner shown to allow-listed staff when they open another customer's
 * TripPlanner chat via the staff "Spoof conversation" form, so it is always
 * obvious they are viewing someone else's conversation rather than their own.
 */
function StaffSpoofBanner({ chatId, onDismiss }: Props) {
  return (
    <Banner
      className="no-print"
      background="critical"
      paletteType="inverse"
      padding={8}
    >
      <Message variant="medium" weight="bold" colour="normal-contrast" align="center">
        <FormattedMessage
          id="IJGeZj5IWF4qkzFod9ew"
          defaultMessage="Staff view: viewing customer conversation #{chatId}"
          description="Banner shown to staff when they are viewing another customer's TripPlanner chat conversation by ID"
          values={{ chatId }}
        />
      </Message>
      <TextButton kind="tertiary" size="small" onClick={onDismiss}>
        <FormattedMessage
          id="JiZzZIvQzjWTWsADUPZG"
          defaultMessage="Dismiss"
          description="Button label that hides the staff customer conversation warning banner"
        />
      </TextButton>
    </Banner>
  )
}

export default StaffSpoofBanner
